import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

export interface Props {
  handleChangeAndContinue: (field: Field, value: string) => void
}

export const ApplicationStepTobaccoUse: React.SFC<LifeInsuranceApplicationProps & Props> = (props) => {
  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(true)
  }, [])

  return (
    <Wrapper {...props}>
      <StepTitle>Are you a tobacco user?</StepTitle>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.TobaccoSmoker}
        onChange={props.handleChangeAndContinue.bind(null, Fields.TobaccoSmoker)}
        styles={styles.formRow}
      />
    </Wrapper>
  )
}
